module.exports = __webpack_public_path__ + "static/media/favorite.98a809ef.svg";


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/images/favorite.svg
// module id = 101
// module chunks = 2